// This file is used for maintain and manage API services.
(function() {
  'use strict';
  angular.module('obex').
  factory('historySms', ['$http', 'obexConstant', 'authService',
    ($http, obexConstant, authService) => {
      return {
        getConversations(startDate, endDate, orgId) {
          const url = `${obexConstant.urlSmsHistory}/admin/organization/${orgId}/${startDate}/${endDate}`;
          return authService.getAuthorizationHeader().then(authHeader =>
            $http.get(url, {
              headers: authHeader,
            }));            
        },
		    /*getConversationsByStatus(startDate, endDate, orgId, statusId) {
          const url = `${obexConstant.urlSmsHistory}/admin/organization/${orgId}/${startDate}/${endDate}/${statusId}`;
          return authService.getAuthorizationHeader().then(authHeader =>
            $http.get(url, {
              headers: authHeader,
            }));            
        },*/
        getDetailedConversation(conversation) {
          const url = `${obexConstant.urlSmsHistory}/admin/conversation/${conversation}`;
          return authService.getAuthorizationHeader().then(authHeader =>
            $http.get(url, {
              headers: authHeader,
            }));
        },
		    getConversationsByAgentIdByStatus(agentId,conversationStatus) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlSmsHistory}/admin/agent/${agentId}/${conversationStatus}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        updateConversationsStatusByConversation(conversationKey, status) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlSmsHistory}/admin/setstatus/${conversationKey}/${status}`;
            return $http.put(url, null, {
              headers: authHeader,
            });
          });          
        }
     };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/historySms.service.js